"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Article = void 0;
const Headline_1 = require("./Headline");
class Article extends Headline_1.Headline {
}
exports.Article = Article;
//# sourceMappingURL=Article.js.map